"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookButtonPosition = void 0;
exports.BookButtonPosition = {
    video: "video",
    first: "first",
    second: "second",
    third: "third",
    mobile: "mobile",
};
//# sourceMappingURL=BookButtonPosition.js.map